import { createAsyncThunk } from "@reduxjs/toolkit";
import { getEnvironmentActivitiesRequest } from "Api/activity/getEnvironmentActivities.request";
import { ACTIVITY_TYPES } from "Constants/constants";
import type { Activity } from "Api/activity/types";
export interface LoadCronActivitiesTypes {
  projectId: string;
  environmentId: string;
  cronName: string;
  count?: number;
}

export const loadCronActivities = createAsyncThunk<
  {
    activities: Activity[];
    projectId: string;
    environmentId: string;
    cronName: string;
  },
  LoadCronActivitiesTypes
>(
  "activity/cron/load",
  async ({ projectId, environmentId, cronName, count = 18 }) => {
    const activities = await getEnvironmentActivitiesRequest({
      projectId,
      encodedEnvId: encodeURIComponent(environmentId),
      cron: cronName,
      count,
      filters: ACTIVITY_TYPES.ENVIRONMENT.CRON
    });

    return {
      activities: activities.reverse(),
      projectId,
      environmentId,
      cronName
    };
  }
);
